import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TravelSolution.css";

const TravelSolution = () => {
  return (
    <>
      <div className="container travel-solutions-section mt-5 pt-md-4 mb-5">
        <div className="row">
          <div className="col-md-12 mt-5">
            <h1 className="text-center headings">
              <span>Business Travel</span> Solutions that Fit Everyone's Needs
            </h1>
          </div>
          <div className="row ps-3">
            <div className="col-md-8 mt-md-5 mt-3 paddingL">
              <h3 className="first-section headings">
                Business Travel Consultants
              </h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  Booking flights, accommodations, and handling travel details
                  should be effortless. Explore how our technology and skilled
                  teams save you time when planning, arranging, and modifying
                  your business trips.
                </p>
              </div>
              {/* <div className="exploreBtn d-flex gap-3">
                                <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">EXPLORE
                                    MORE</button>
                                <button className="arrow-btn border-0 bg-transparent">
                                    <LazyLoadImage src={Rightarrow} alt="right-arrow" className="mt-1" />
                                </button>
                            </div> */}
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Travel%20C.png"
                  alt="image"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3">
            <div className="col-md-8 mt-md-5 mt-3 paddingL">
              <h3 className="second-section headings">Corporate Travelers</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  Equip your teams to travel with confidence and simplify their
                  business journeys. Wherever they're headed, our user-friendly
                  booking platform, mobile app, and 24/7 support are always by
                  their side.
                </p>
              </div>
              {/* <div className="exploreBtn d-flex gap-3">
                                <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">EXPLORE
                                    MORE</button>
                                <button className="arrow-btn border-0 bg-transparent">
                                    <LazyLoadImage src={Rightarrow} alt="right-arrow" className="mt-1" />
                                </button>
                            </div> */}
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Corporate%20T.png"
                  alt="image"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3">
            <div className="col-md-8 mt-md-5 mt-3 paddingL">
              <h3 className="third-section headings">Corporate Managers</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  From company-wide travel and expense policies to financial
                  outcomes, we collaborate with and support those making key
                  travel decisions. Learn how we can ensure the safety of your
                  travelers, reduce travel costs, and align with your strategy.
                </p>
              </div>
              {/* <div className="exploreBtn d-flex gap-3">
                                <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">EXPLORE
                                    MORE</button>
                                <button className="arrow-btn border-0 bg-transparent">
                                    <LazyLoadImage src={Rightarrow} alt="right-arrow" className="mt-1" />
                                </button>
                            </div> */}
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Corporate%20M.png"
                  alt="image"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3">
            <div className="col-md-8 mt-md-5 mt-3 paddingL">
              <h3 className="fourth-section headings">Procurement Team</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className=" mt-4 fs5">
                  We assist procurement teams by streamlining travel processes,
                  ensuring cost efficiency, and simplifying booking procedures.
                  Our personalized solutions help manage travel logistics,
                  provide real-time support, and optimize travel budgets,
                  allowing your team to focus on strategic objectives while
                  traveling with ease.
                </p>
              </div>
              {/* <div className="exploreBtn d-flex gap-3">
                                <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">EXPLORE
                                    MORE</button>
                                <button className="arrow-btn border-0 bg-transparent">
                                    <LazyLoadImage src={Rightarrow} alt="right-arrow" className="mt-1" />
                                </button>
                            </div> */}
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Procurement.png"
                  alt="image"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TravelSolution;
